import {invoiceService} from '../../_services'

export default {
  state: {
    employeeInvoices: [],
    customerInvoices: [],
    maxEmployeeInvoices: 10,
    maxCustomerInvoices: 10
  },
  mutations: {
    setEmployeeInvoices (state, payload) {
      state.employeeInvoices = payload
    },
    setCustomerInvoices (state, payload) {
      state.customerInvoices = payload
    },
    setMaxEmployeeInvoices (state, payload) {
      state.maxEmployeeInvoices = payload
    },
    setMaxCustomerInvoices (state, payload) {
      state.maxCustomerInvoices = payload
    },
    setCustomerInvoice (state, payload) {
      state.customerInvoices.forEach(group => {
        const foundIndex = group.invoices.findIndex(customerInvoice => customerInvoice.id === payload.id)
        if (foundIndex > -1) group.invoices.splice(foundIndex, 1, payload)
      })
    },
    addEmployeeInvoices (state, payload) {
      if (state.employeeInvoices.length <= (state.maxEmployeeInvoices - payload.length)) {
        // Month level
        payload.forEach(responseMonth => {
          if (state.employeeInvoices.length === 0) {
            state.employeeInvoices.push(responseMonth)
          } else {
            let wasDateModified = false
            state.employeeInvoices.forEach(currentMonth => {
              // Invoices level
              if (currentMonth.month === responseMonth.month) {
                responseMonth.invoices.forEach(tracking => currentMonth.invoices.push(tracking))
                wasDateModified = true
              }
            })
            if (!wasDateModified) {
              state.employeeInvoices.push(responseMonth)
            }
          }
        })
      }
    },
    addCustomerInvoices (state, payload) {
      if (state.customerInvoices.length <= (state.maxCustomerInvoices - payload.length)) {
        // Month level
        payload.forEach(responseMonth => {
          if (state.customerInvoices.length === 0) {
            state.customerInvoices.push(responseMonth)
          } else {
            let wasDateModified = false
            state.customerInvoices.forEach(currentMonth => {
              // Invoices level
              if (currentMonth.month === responseMonth.month) {
                responseMonth.invoices.forEach(tracking => currentMonth.invoices.push(tracking))
                wasDateModified = true
              }
            })
            if (!wasDateModified) {
              state.customerInvoices.push(responseMonth)
            }
          }
        })
      }
    }
  },
  actions: {
    loadEmployeeInvoices ({dispatch, commit}, filter) {
      dispatch('startDataLoading')
      invoiceService.getEmployeeInvoices(filter.page, filter.size)
        .then(response => {
          commit('setMaxEmployeeInvoices', response.data.totalElements)
          commit('addEmployeeInvoices', response.data.content)
        })
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopDataLoading'))
    },
    loadCustomerInvoices ({dispatch, commit}, filter) {
      dispatch('startDataLoading')
      invoiceService.getCustomerInvoices(filter.page, filter.size)
        .then(response => {
          commit('setMaxCustomerInvoices', response.data.totalElements)
          commit('addCustomerInvoices', response.data.content)
        })
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopDataLoading'))
    },
    openInvoice ({dispatch}, invoiceId) {
      invoiceService.getInvoice(invoiceId)
        .then(response => dispatch('handlePdfDownload', response))
        .catch(error => dispatch('handleError', error))
    },
    openTurnover ({dispatch}, month) {
      invoiceService.getTurnover(month)
        .then(response => dispatch('handlePdfDownload', response))
        .catch(error => dispatch('handleError', error))
    },
    releaseInvoice ({dispatch, commit}, invoiceId) {
      dispatch('startDataLoading')
      invoiceService.releaseInvoice(invoiceId)
        .then(response => {
          commit('setCustomerInvoice', response.data)
        })
        .then(() => dispatch('showNotification', {
          title: 'Abrechnung erfolgreich veröffentlicht',
          type: 'primary'
        }))
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopDataLoading'))
    },
    sendInvoice ({dispatch, commit}, invoiceId) {
      dispatch('startDataLoading')
      invoiceService.sendInvoice(invoiceId)
        .then(response => {
          commit('setCustomerInvoice', response.data)
        })
        .then(() => dispatch('showNotification', {
          title: 'Abrechnung erfolgreich versendet',
          type: 'primary'
        }))
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopDataLoading'))
    },
    bulkCustomerInvoiceDownloadByInvoices ({dispatch, commit}, invoiceIds) {
      dispatch('startDataLoading')
      invoiceService.getCustomerInvoicesByInvoices(invoiceIds)
        .then(response => dispatch('handleZipDownload', response))
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopDataLoading'))
    },
    bulkEmployeeInvoiceDownloadByInvoices ({dispatch, commit}, invoiceIds) {
      dispatch('startDataLoading')
      invoiceService.getEmployeeInvoicesByInvoices(invoiceIds)
        .then(response => dispatch('handleZipDownload', response))
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopDataLoading'))
    },
    bulkCustomerInvoiceDownloadByMonth ({dispatch, commit}, month) {
      dispatch('startDataLoading')
      invoiceService.getCustomerInvoicesByMonth(month)
        .then(response => dispatch('handleZipDownload', response))
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopDataLoading'))
    },
    bulkEmployeeInvoiceDownloadByMonth ({dispatch, commit}, month) {
      dispatch('startDataLoading')
      invoiceService.getEmployeeInvoicesByMonth(month)
        .then(response => dispatch('handleZipDownload', response))
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopDataLoading'))
    },
    bulkInvoiceReleaseByInvoices ({dispatch, commit}, invoiceIds) {
      dispatch('startDataLoading')
      invoiceService.releaseInvoicesByInvoices(invoiceIds)
        .then(response => {
          response.data.forEach(invoice => commit('setCustomerInvoice', invoice))
          dispatch('showNotification', {
            title: response.data.length + ' Abrechnung(en) erfolgreich veröffentlicht',
            type: 'primary'
          })
        })
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopDataLoading'))
    },
    bulkInvoiceReleaseByMonth ({dispatch, commit}, month) {
      dispatch('startDataLoading')
      invoiceService.releaseInvoicesByMonth(month)
        .then(response => {
          response.data.forEach(invoice => commit('setCustomerInvoice', invoice))
          dispatch('showNotification', {
            title: response.data.length + ' Abrechnung(en) erfolgreich veröffentlicht',
            type: 'primary'
          })
        })
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopDataLoading'))
    },
    bulkInvoiceSendByInvoices ({dispatch, commit}, invoiceIds) {
      dispatch('startDataLoading')
      invoiceService.sendInvoicesByInvoices(invoiceIds)
        .then(response => {
          response.data.forEach(invoice => commit('setCustomerInvoice', invoice))
          dispatch('showNotification', {
            title: response.data.length + ' Abrechnungen erfolgreich versendet',
            type: 'primary'
          })
        })
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopDataLoading'))
    },
    bulkInvoiceSendByMonth ({dispatch, commit}, month) {
      dispatch('startDataLoading')
      invoiceService.sendInvoicesByMonth(month)
        .then(response => {
          response.data.forEach(invoice => commit('setCustomerInvoice', invoice))
          dispatch('showNotification', {
            title: response.data.length + ' Abrechnungen erfolgreich versendet',
            type: 'primary'
          })
        })
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopDataLoading'))
    },
    resetEmployerInvoices ({commit}) {
      commit('setEmployeeInvoices', [])
      commit('setMaxEmployeeInvoices', 10)
    },
    resetCustomerInvoices ({commit}) {
      commit('setCustomerInvoices', [])
      commit('setMaxCustomerInvoices', 10)
    },
    handlePdfDownload ({dispatch, commit}, response) {
      let a = document.createElement('a')
      document.body.appendChild(a)
      const blob = new Blob([response.data], {type: 'application/pdf'})
      const url = URL.createObjectURL(blob)
      a.style = 'display: none'
      a.href = url

      let filename = ''
      let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
      let matches = filenameRegex.exec(response.request.getResponseHeader('Content-Disposition'))
      if (matches != null && matches[1]) {
        filename = matches[1].replace(/['"]/g, '')
      }

      a.download = filename
      a.click()
      window.URL.revokeObjectURL(url)
    },
    handleZipDownload ({dispatch, commit}, response) {
      let a = document.createElement('a')
      document.body.appendChild(a)
      const blob = new Blob([response.data], {type: 'application/zip'})
      const url = URL.createObjectURL(blob)
      a.style = 'display: none'
      a.href = url
      let filename = ''
      let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
      let matches = filenameRegex.exec(response.request.getResponseHeader('Content-Disposition'))
      if (matches != null && matches[1]) {
        filename = matches[1].replace(/['"]/g, '')
      }
      a.download = filename
      a.click()
      window.URL.revokeObjectURL(url)
    }
  },
  getters: {
    employeeInvoices (state) {
      return state.employeeInvoices
    },
    customerInvoices (state) {
      return state.customerInvoices
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/invoice/index.js